var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('font-awesome-icon',{class:_vm.buttonClassFromState,attrs:{"icon":_vm.buttonIconFromState,"size":"lg"}}),_vm._v(" "+_vm._s(_vm.buttonLabelFromState)+" "),_c('b-badge',{staticClass:"d-none"},[_vm._v(_vm._s(_vm.orderState))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }